module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-60x60-6ea9a3d8af80073af2ad14df352ff4e9.png";